angular.module('aprima-legacy-common').factory('DashboardStructure',
    ['ServerInfoRepository', 'VersionService', 'CurrentUser', 'DeviceSettings', 'widgetViews', 'configuration',
        function (ServerInfoRepository, VersionService, CurrentUser, DeviceSettings, widgetViews, configuration) {
            'use strict';

            function mapV1ConfigurationsToV2(configs) {
                var result = _.map(configs, mapV1ConfigurationToV2);

                return result;

                function mapV1ConfigurationToV2(config) {
                    var result = {
                        Id: config.Type,
                        ExternalId: '',
                        Name: config.Type,
                        DisplayOrder: config.Type === 'All' ? 0 : 1,
                        PhoneTiles: mapTiles(config, 1),
                        TabletTiles: mapTiles(config, 2),
                        DesktopTiles: mapTiles(config, 3)
                    };

                    return result;
                }

                function mapTiles(config, numColumns) {
                    var tiles = _(config.WidgetDescriptors)
                        .filter(function (tile) {
                            return tile.Name !== 'header';
                        })
                        .map(_.partialRight(mapTile, numColumns))
                        .value();

                    return tiles;
                }

                function mapTile(tile, index, collection, numColumns) {
                    var result = {
                        Id: tile.Id,
                        TileDescriptorId: _.find(widgetViews, {name: tile.Name}).id,
                        Name: tile.Name,
                        Heading: tile.Heading,
                        ColumnSpan: Math.min(DeviceSettings.isPhoneOrOverride || tile.Column !== 'dblCol' ? 1 : 2, numColumns || 2),
                        IsCollapsed: tile.Name === 'remarks' ? false : true,
                        Filter: tile.Filter
                    };

                    return result;
                }
            }

            return {
                get: function (numColumns) {
                    var routeSuffix = 'phone';

                    switch (numColumns) {
                        case 1:
                            routeSuffix = 'phone';
                            break;
                        case 2:
                            routeSuffix = 'tablet';
                            break;
                        case 3:
                            routeSuffix = 'desktop';
                            break;
                        case undefined:
                        case null:
                            routeSuffix = '';
                            break;
                        default:
                            throw new Error('Unsupported number of columns for dashboard configuration: ' + numColumns);
                    }

                    var isTileV2 = VersionService.checkVersionValid(ServerInfoRepository.getPrmAssemblyVersion(), configuration.MIN_PRM_DASHBOARD_VERSION);
                    return isTileV2 ?
                    {
                        repositoryRoute: 'settings/patient-dashboards/' + routeSuffix,
                        mapFn: _.identity
                    } :
                    {
                        repositoryRoute: 'settings/patientdashboards/' + CurrentUser.get().userId,
                        mapFn: mapV1ConfigurationsToV2
                    };
                }
            };
        }]);

